import { RequiredTheme, ResponsiveValue, system, Theme } from 'styled-system';
import * as CSS from 'csstype';

export const objectFit = system({
    objectFit: true,
});

export interface ObjectFitProps<ThemeType extends Theme = RequiredTheme> {
    objectFit?: ResponsiveValue<CSS.Property.ObjectFit, ThemeType> | undefined;
}
